import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    total_station_num:'',// 综合态势-当前充电站数量  ps：跃增通道数-充电枪，和此数据共用
    stationAccessNum:'',// 综合态势-当前换电站数量  ps：跃增通道数-换电枪，和此数据共用
  },
  mutations: {
    SETtotal_station_num(state,value){
      state.total_station_num = value
    },
    SETStationAccessNum(state,value){
      state.stationAccessNum = value
    }
  },
  actions: {
  },
  modules: {
  }
})
